var _defs, _path, _path2, _line, _circle, _circle2, _polyline, _line2, _path3, _path4, _line3, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtendtheLifeofYourVehiclecopy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448.55 448.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:9.98px;}.cls-1,.cls-2{fill:none;stroke:#f26725;stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke-width:9.22px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m118.37,183.88l43.69-5.49c4.18-.53,8.93-.85,14.04-.96,37.32-.83,73.96,10.05,105.19,30.5l37.31,24.43,43.76,4.21c20.49,1.98,36.12,19.2,36.12,39.79v31.21c0,3.26-2.64,5.9-5.9,5.9h-13.51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m76.86,307.98l-19.37-10.97c-4.58-2.6-7.41-7.45-7.41-12.72v-44.7c0-3.11.99-6.13,2.83-8.64l15.86-21.65c2.13-2.91,2.06-6.89-.17-9.72l-6.76-8.58,56.54-7.11"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 267.51,
    y1: 313.48,
    x2: 165.53,
    y2: 313.48
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 324.5,
    cy: 301.51,
    r: 38.89
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 128.52,
    cy: 301.51,
    r: 38.89
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "318.6 232.37 125.95 232.37 106.91 208.85"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 176.65,
    y1: 177.4,
    x2: 198.89,
    y2: 232.37
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m383.85,279.72h-5.12c-1.11,0-2.13-.6-2.68-1.57l-9.83-17.49c-1.15-2.05.33-4.58,2.68-4.58h13.98"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m63.47,239.98h4.11c1.72,0,3.25,1.1,3.79,2.72l5.27,15.63c.88,2.6-1.06,5.28-3.79,5.28h-22.78"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 234.35,
    y1: 253.98,
    x2: 214.2,
    y2: 253.98
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m380.76,178.14h0c-11.23,4.11-20.01,15.42-23.19,29.9h0c-3.19-14.48-11.96-25.8-23.19-29.9h0c11.23-4.11,20.01-15.42,23.19-29.9h0c3.19,14.48,11.96,25.8,23.19,29.9h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m308.8,138.05h0c-11.23,4.11-20.01,15.42-23.19,29.9h0c-3.19-14.48-11.96-25.8-23.19-29.9h0c11.23-4.11,20.01-15.42,23.19-29.9h0s0,0,0,0c3.19,14.48,11.96,25.8,23.19,29.9h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendtheLifeofYourVehiclecopy2);
export default __webpack_public_path__ + "static/media/Extend the Life of Your Vehicle copy 2.bf33ba5971bdb64684b79077f7f86901.svg";
export { ForwardRef as ReactComponent };